import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';// 请替换为实际接口路径
import { momentFormats } from '../../../../../utils/utils'; // 请替
import { externalBillService } from "../../externalBillService";

// 定义报价历史数据类型
interface QuoteHistoryItem {
    id: string;
    supplierName: string;
    createTime: string;
    isTransport: 0 | 1;
    route?: string;
    itemAmount: string;
    itemNote?: string;
    materialAmount: string;
    materialNote?: string;
}

interface QuoteHistoryModalProps {
    visible: boolean;
    onCancel: () => void;
    orderCode: string;
    quoteId: string;
}

export const QuoteHistoryModal: React.FC<QuoteHistoryModalProps> = ({
    visible,
    onCancel,
    orderCode,
    quoteId
}) => {
    const [quoteHistoryList, setQuoteHistoryList] = useState<QuoteHistoryItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    // 获取报价历史数据
    const fetchQuoteHistory = async () => {
        if (!orderCode || !quoteId) return;

        try {
            setIsLoading(true);
            const response = await externalBillService.getQuoteHistory({
                code: orderCode,
                supplierName: quoteId
            });



            setQuoteHistoryList(response.retData);
        } catch (error) {
            console.error('获取报价历史失败:', error);
            message.error('获取报价历史失败，请重试');
        } finally {
            setIsLoading(false);
        }
    };

    // 当弹窗显示或相关参数变化时重新获取数据
    useEffect(() => {
        if (visible) {
            fetchQuoteHistory();
        } else {
            // 关闭时清空数据
            setQuoteHistoryList([]);
        }
    }, [visible, orderCode, quoteId]);

    return (
        <Modal
            title="报价历史记录"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={600}
            maskClosable={false}
            destroyOnClose={true}
        >
            <div style={{
                maxHeight: '500px',
                overflowY: 'auto',
                padding: '5px 0'
            }}>
                {isLoading ? (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '200px'
                    }}>
                        <span>加载中...</span>
                    </div>
                ) : quoteHistoryList.length === 0 ? (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '50px 0'
                    }}>
                        <img
                            src="https://fserv-priv-1301309125.cos.ap-beijing.myqcloud.com/74c0969c709c42b5ad19e26d723eb009.png"
                            alt="暂无数据"
                            style={{
                                width: '100px',
                                height: '100px',
                                marginBottom: '15px',
                                opacity: 0.5
                            }}
                        />
                        <p style={{
                            fontSize: '18px',
                            color: '#999'
                        }}>暂无报价历史记录</p>
                    </div>
                ) : (
                    <div style={{ padding: '5px' }}>
                        {quoteHistoryList.map((item, index) => (
                            <div key={index} style={{
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '10px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                                position: 'relative'
                            }}>
                                {/* 报价头部信息 */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '10px'
                                }}>
                                    <span style={{
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        color: '#333'
                                    }}>{item.supplierName}</span>
                                    <span style={{
                                        fontSize: '16px',
                                        color: '#999'
                                    }}>{momentFormats(item.createTime)}</span>
                                </div>

                                {/* 分隔线 */}
                                <div style={{
                                    height: '1px',
                                    backgroundColor: '#f0f0f0',
                                    margin: '5px 0'
                                }}></div>

                                {/* 报价详情 */}
                                <div style={{ marginTop: '5px' }}>
                                    <div style={{ display: 'flex', padding: '4px 0' }}>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#666',
                                            minWidth: '80px'
                                        }}>是否拖车：</span>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#333',
                                            flex: 1,
                                            wordBreak: 'break-all'
                                        }}>{item.isTransport === 0 ? '是' : '否'}</span>
                                    </div>

                                    {item.isTransport === 0 && (
                                        <div style={{ display: 'flex', padding: '4px 0' }}>
                                            <span style={{
                                                fontSize: '17px',
                                                color: '#666',
                                                minWidth: '80px'
                                            }}>路线：</span>
                                            <span style={{
                                                fontSize: '17px',
                                                color: '#333',
                                                flex: 1,
                                                wordBreak: 'break-all'
                                            }}>{item.route || '无'}</span>
                                        </div>
                                    )}

                                    {/* 虚线分隔线 */}
                                    <div style={{
                                        height: '1px',
                                        borderBottom: '1px dashed #f0f0f0',
                                        margin: '5px 0'
                                    }}></div>

                                    <div style={{ display: 'flex', padding: '4px 0' }}>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#666',
                                            minWidth: '80px'
                                        }}>工时费用：</span>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#333',
                                            flex: 1,
                                            wordBreak: 'break-all'
                                        }}>{item.itemAmount}</span>
                                    </div>

                                    <div style={{ display: 'flex', padding: '4px 0' }}>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#666',
                                            minWidth: '80px'
                                        }}>维修内容：</span>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#333',
                                            flex: 1,
                                            wordBreak: 'break-all'
                                        }}>{item.itemNote || '无'}</span>
                                    </div>

                                    {/* 虚线分隔线 */}
                                    <div style={{
                                        height: '1px',
                                        borderBottom: '1px dashed #f0f0f0',
                                        margin: '5px 0'
                                    }}></div>

                                    <div style={{ display: 'flex', padding: '4px 0' }}>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#666',
                                            minWidth: '80px'
                                        }}>配件费用：</span>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#333',
                                            flex: 1,
                                            wordBreak: 'break-all'
                                        }}>{item.materialAmount}</span>
                                    </div>

                                    <div style={{ display: 'flex', padding: '4px 0' }}>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#666',
                                            minWidth: '80px'
                                        }}>更换配件：</span>
                                        <span style={{
                                            fontSize: '17px',
                                            color: '#333',
                                            flex: 1,
                                            wordBreak: 'break-all'
                                        }}>{item.materialNote || '无'}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Modal>
    );
};